export interface IScriptsRequest {
  igsCustomerNumber: string,
  isAchPayment: boolean,
  isCreditCardPayment: boolean,
  isAutoPayAuth: boolean,
  paymentAmount: number,
  lastFourDigits: string
}

export class ScriptsRequest implements IScriptsRequest {
  igsCustomerNumber: string;
  isAchPayment: boolean;
  isCreditCardPayment: boolean;
  isAutoPayAuth: boolean;
  paymentAmount: number;
  lastFourDigits: string;
}